var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-popup',{attrs:{"position":"bottom"},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('van-area',{attrs:{"area-list":_vm.areaList,"columns-num":_vm.columnsNum},on:{"confirm":_vm.confirm,"cancel":function($event){_vm.show = false}}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }